import {wrap} from "./utilities/wrap";

export function addTableWrapper(query = document.querySelectorAll('.textcontent table, .modal__body table, .itemcardMainDescription table')){
    wrap(query,"div","table_wrapper");
}